/**
 * Miroir frontend de la matrice RBAC backend.
 * Preferer user.effectivePermissions renvoyé par /auth/me quand disponible.
 */

export const PERMISSIONS = {
  USERS_READ: 'users:read',
  USERS_WRITE: 'users:write',
  USERS_ROLE: 'users:role',
  USERS_SUSPEND: 'users:suspend',
  VEHICLES_READ: 'vehicles:read',
  VEHICLES_WRITE: 'vehicles:write',
  VEHICLES_VERIFY: 'vehicles:verify',
  BOOKINGS_READ: 'bookings:read',
  BOOKINGS_WRITE: 'bookings:write',
  AGENCIES_APPROVE: 'agencies:approve',
  KYC_VERIFY: 'kyc:verify',
  AUDIT_READ: 'audit:read',
  SETTINGS_WRITE: 'settings:write',
};

export const DEFAULT_ROLE_PERMISSIONS = {
  super_admin: Object.values(PERMISSIONS),
  admin: [
    PERMISSIONS.USERS_READ,
    PERMISSIONS.USERS_WRITE,
    PERMISSIONS.USERS_ROLE,
    PERMISSIONS.USERS_SUSPEND,
    PERMISSIONS.VEHICLES_READ,
    PERMISSIONS.VEHICLES_WRITE,
    PERMISSIONS.VEHICLES_VERIFY,
    PERMISSIONS.BOOKINGS_READ,
    PERMISSIONS.BOOKINGS_WRITE,
    PERMISSIONS.AGENCIES_APPROVE,
    PERMISSIONS.KYC_VERIFY,
    PERMISSIONS.AUDIT_READ,
    PERMISSIONS.SETTINGS_WRITE,
  ],
  staff: [
    PERMISSIONS.USERS_READ,
    PERMISSIONS.VEHICLES_READ,
    PERMISSIONS.BOOKINGS_READ,
    PERMISSIONS.KYC_VERIFY,
    PERMISSIONS.AUDIT_READ,
  ],
  vendor: [
    PERMISSIONS.VEHICLES_READ,
    PERMISSIONS.VEHICLES_WRITE,
    PERMISSIONS.BOOKINGS_READ,
    PERMISSIONS.BOOKINGS_WRITE,
  ],
  user: [PERMISSIONS.BOOKINGS_READ, PERMISSIONS.BOOKINGS_WRITE],
};

export const getEffectivePermissions = (user) => {
  if (!user) return [];
  if (Array.isArray(user.effectivePermissions) && user.effectivePermissions.length > 0) {
    return user.effectivePermissions;
  }
  const defaults = DEFAULT_ROLE_PERMISSIONS[user.role] || DEFAULT_ROLE_PERMISSIONS.user;
  const overrides = Array.isArray(user.permissions) ? user.permissions : [];
  return Array.from(new Set([...defaults, ...overrides]));
};

export const userHasPermission = (user, permission) =>
  getEffectivePermissions(user).includes(permission);

export const userHasAnyPermission = (user, permissions = []) => {
  const effective = getEffectivePermissions(user);
  return permissions.some((p) => effective.includes(p));
};

export const userHasRole = (user, ...roles) => {
  if (!user?.role) return false;
  return roles.includes(user.role);
};

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  staff: 'Staff',
  vendor: 'Vendeur',
  user: 'Client',
};

export const ASSIGNABLE_ROLES = ['super_admin', 'admin', 'staff', 'vendor', 'user'];
